// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_MMd","input":"styles_input__3GjbW"};